import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";

import App from "./App";
import { SettingsProvider } from "./utils/SettingsContext";
import { AuthProvider } from "./pages/AuthContext";
import logger from "./utils/logger";
import { applyCSP } from "./utils/csp";

// Configurar logging seguro
if (process.env.NODE_ENV === 'production') {
  // Deshabilitar console.log en producción
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
}

// Aplicar Content Security Policy
applyCSP(process.env.NODE_ENV === 'development');

const root = createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <AuthProvider>
      <SettingsProvider>
        <App />
      </SettingsProvider>
    </AuthProvider>
  </StrictMode>
);